import * as types from './agency-tools.types';
import * as constants from './agency-tools.constants';

export const initialAgencyToolsPage = (): types.IInitialAgencyToolsPage => ({
  type: constants.AGENCY_TOOLS_PAGE,
});
